import { buildValidator } from "./buildValidator";

export const confirmationNumber = buildValidator("Enter your 20-digit confirmation number", (value, input) => {
  const rsRequired = input?.getAttribute("rsrequired");
  if (rsRequired && /\{val:false,/.test(rsRequired) && !value) {
    return true;
  }
  return !!value && /^([A-Za-z0-9]{1,20})$/.test(value.toString());
});
